import type { CustomZIndex } from '@src/theme';

export const zIndex: CustomZIndex = {
  appBar: 1600,
  appDrawer: 1400,
  appDrawerBackdrop: 1399,
  settings: 1250,
  drawer: 200,
  fab: 1050,
  mobileStepper: 1000,
  modal: 1700,
  menuModal: 1500,
  snackbar: 1400,
  speedDial: 1050,
  tooltip: 1500,
};
